import { AxiosResponse } from 'axios';

import requestExodus from 'lib/api/instances/exodus';
import { API_SECURITIES_GENERAL_URL } from 'constants/api';
import { BasicResponse } from '../../../@types/api-response';
import {
  COMMUNITY_MEMBER_STATUS,
  CommunityDataPayload,
  CommunityInfo,
  CommunityMembersResponse,
  CommunityStatusDataPayload,
} from '../../../@types/community';

const request = requestExodus.defaultInstance;
const requestWithoutAlert = requestExodus.noAlert;

type GetRefInfoPayload = BasicResponse<CommunityInfo>;
export const getReferralInfo = () =>
  request.get<GetRefInfoPayload, AxiosResponse<GetRefInfoPayload>>(
    `${API_SECURITIES_GENERAL_URL}/remisier/info`,
  );

type GetRefStatusPayload = BasicResponse<CommunityStatusDataPayload>;
export const getReferralStatus = () =>
  requestWithoutAlert.get<
    GetRefStatusPayload,
    AxiosResponse<GetRefStatusPayload>
  >(`${API_SECURITIES_GENERAL_URL}/remisier/referral/status`);

type GetRefByCodePayload = BasicResponse<CommunityDataPayload>;
export const getReferralByCode = (code: string) =>
  request.get<GetRefByCodePayload, AxiosResponse<GetRefByCodePayload>>(
    `${API_SECURITIES_GENERAL_URL}/remisier/referral/${code}`,
  );

type GetRefMembers = BasicResponse<CommunityMembersResponse>;
type GetRefMembersParams = {
  keyword?: string;
  cursor?: number;
  status?: COMMUNITY_MEMBER_STATUS;
  startDate?: string; // date in DD-MM-YYY
  endDate?: string; // date in DD-MM-YYY
};

export const getReferralMembers = ({
  keyword,
  status,
  startDate,
  endDate,
  cursor,
}: GetRefMembersParams) =>
  request.get<GetRefMembers, AxiosResponse<GetRefMembers>>(
    `${API_SECURITIES_GENERAL_URL}/remisier/affiliate/members`,
    {
      params: {
        search: keyword !== '' ? keyword : undefined,
        status: status !== 'MEMBER_STATUS_UNSPECIFIED' ? status : undefined,
        start_date: startDate,
        end_date: endDate,
        cursor,
      },
    },
  );

export const postApplyReferral = (code: string) =>
  request.post<GetRefByCodePayload>(
    `${API_SECURITIES_GENERAL_URL}/remisier/referral/apply`,
    { code },
  );

export const deleteReferral = () =>
  request.delete(`${API_SECURITIES_GENERAL_URL}/remisier/referral`);

const communityAPI = {
  getReferralInfo,
  getReferralStatus,
  getReferralByCode,
  getReferralMembers,
  postApplyReferral,
  deleteReferral,
};

export default communityAPI;
